import { render, staticRenderFns } from "./RequisitionCard.vue?vue&type=template&id=2ace5ec8&scoped=true"
import script from "./RequisitionCard.vue?vue&type=script&lang=js"
export * from "./RequisitionCard.vue?vue&type=script&lang=js"
import style0 from "./RequisitionCard.vue?vue&type=style&index=0&id=2ace5ec8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ace5ec8",
  null
  
)

export default component.exports